import React, { lazy } from 'react';
import { Card, CardContent } from './ui/Card';
import { ArrowRight } from 'lucide-react';
export function ServicesGrid() {
  const services = [{
    title: 'Window Cleaning',
    description: 'Streak-free, spot-free results for homes, offices, storefronts, and multi-story buildings using safe, effective methods.',
    image: 'https://cdn.magicpatterns.com/uploads/3qqzLSwWVx6ommVQ2gRyAG/7d852f67-192c-4fcf-b263-e90abc474947-2880w.webp'
  }, {
    title: 'Pressure & Soft Washing',
    description: "Building exteriors, driveways, patios, decks, sidewalks, and walls — restoring your property's appearance.",
    image: 'https://cdn.magicpatterns.com/uploads/6nVFfG4YQ7GiCRPwu4TtFf/696844b5-7352-4386-a28b-364eb2efa070-2880w.webp'
  }, {
    title: 'Solar Panel Cleaning',
    description: "Pure DI water cleaning with drones — no brushes or chemicals. Maximize your panels' efficiency.",
    image: 'https://cdn.magicpatterns.com/uploads/kvkNUAJRfNuwNdc2TDmBMU/df81bfb0-935b-4366-8d87-b54da01ca40c-2880w.webp'
  }, {
    title: 'Roof Cleaning',
    description: 'Gentle soft wash techniques that remove buildup without damaging shingles, tiles, or membranes.',
    image: 'https://cdn.magicpatterns.com/uploads/2YTbk6CTdfJ43YbV5wav2i/IMG_0750-2880w.webp'
  }, {
    title: 'Surface Cleaning',
    description: "Concrete, stucco, hardscape, and more — cleaned with precision to extend your property's lifespan.",
    image: 'https://cdn.magicpatterns.com/uploads/fQ8h9QBdzhQVFKG25UBDbH/IMG_0921-4a521ca9-5a3c4a3a-2880w.webp'
  }, {
    title: 'Fleet & Commercial Vehicles',
    description: 'Top-down cleaning for RVs, semi trucks, and commercial fleets. Spot-free, scratch-free, roof included.',
    image: 'https://cdn.magicpatterns.com/uploads/rs7cyRwG9vKJVftwpMf7zY/9940f1d9-e635-4f4a-bd8c-3fdd4251901d-1920w.webp'
  }];
  return <section className="bg-[#F5F7FA] py-20 lg:py-28 font-heading" data-id="element-161">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-162">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-163">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B3A5C] mb-4 uppercase tracking-tight" data-id="element-164">
            Our Services
          </h2>
          <p className="text-lg text-[#1E1E1E]/80" data-id="element-165">
            Full-service exterior cleaning for commercial and residential
            properties — from rooftops to driveways.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-166">
          {services.map((service, index) => <Card key={index} className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border-none group flex flex-col h-full" data-id="element-167">
              <div className="relative h-48 sm:h-56 w-full overflow-hidden" data-id="element-168">
                <div className="absolute inset-0 bg-[#1B3A5C]/20 group-hover:bg-transparent transition-colors duration-300 z-10" data-id="element-169" />
                <img src={service.image} alt={service.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" data-id="element-170" />
              </div>
              <CardContent className="p-6 flex-grow flex flex-col" data-id="element-171">
                <h3 className="text-xl font-bold text-[#1B3A5C] mb-3" data-id="element-172">
                  {service.title}
                </h3>
                <p className="text-[#1E1E1E] leading-relaxed mb-6 flex-grow" data-id="element-173">
                  {service.description}
                </p>
                <a href="#" className="text-[#F5A623] font-bold flex items-center gap-2 hover:text-[#E09520] transition-colors mt-auto w-fit group/link" data-id="element-174">
                  Learn More
                  <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" data-id="element-175" />
                </a>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}